"use strict";

function getValue(data) {
  if(typeof data === "function") {
    return data();
  }

  return data;
}

function toCamelCase(str) {
  return str.replace(/-([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });
}

function BindEarlyAttrCtrl(elem, attrs, scope) {
  var data = scope.$eval(attrs.bindEarlyAttr);

  for (var attr in data) {
    if (data.hasOwnProperty(attr)) {
      /* Update the internal representation to propagate to other directives */
      attrs[toCamelCase(attr)] = getValue(data[attr]);

      elem.attr(attr, getValue(data[attr]));
    }
  }
}

function BindEarlyAttr() {
  return {
    priority:   999999,
    restrict:   'A',
    controller: ['$element', '$attrs', '$scope', BindEarlyAttrCtrl]
  };
}

angular.module('dokiv')
  .directive('bindEarlyAttr', BindEarlyAttr);



//////////////////
// WEBPACK FOOTER
// ./scripts/app/BindEarlyAttrDirective.js
// module id = 237
// module chunks = 0